import { useBusinessEngineApi } from 'infrastructure/api';
import { FormFieldsData } from 'framework/form';
import purchaseRequestValidation from './purchaseRequestValidation';

interface PurchaseRequestData {
  officeLocation: string;
  vendorId: string;
  requiredDeliveryDate: string;
  purchaseDescription: string;
  purchasePurpose: string;
  isPaymentConfirmNeeded: 'YES' | 'NO';
  purchaseInvoice?: string | null;
}

const usePurchaseRequestService = () => {
  const { sendPostRequest } = useBusinessEngineApi();

  const createPurchaseRequest = async (data: FormFieldsData) => {
    const requestData: PurchaseRequestData = {
      officeLocation: data.officeLocation,
      vendorId: data.vendorId,
      requiredDeliveryDate: data.requiredDeliveryDate,
      purchaseDescription: data.purchaseDescription,
      purchasePurpose: data.purchasePurpose,
      isPaymentConfirmNeeded: data.isPaymentConfirmNeeded,
      purchaseInvoice: data.purchaseInvoice,
    };

    const response = await sendPostRequest('/onestop/FIN04', requestData);
    return response.json();
  };

  const getValidationSchema = () => Promise.resolve(purchaseRequestValidation);

  return {
    createPurchaseRequest,
    getValidationSchema,
  };
};

export default usePurchaseRequestService;
